import { Direccion } from './../../../store/global/global.state';
import { Component, HostListener, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { GlobalActions } from 'src/app/store/global/global.actions';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-institucion-gmap',
  templateUrl: './institucion-gmap.component.html',
  styleUrls: ['./institucion-gmap.component.scss'],
})
export class InstitucionGmapComponent implements OnInit {

  @Select((state:any) => state.global.footer.direccionGmap) direccionGmap$!: Observable<Direccion>;

  constructor(private store: Store) {}
  @HostListener('document:keydown', ['$event']) private handleKeydown(
    event: KeyboardEvent
  ) {
    if (event.key === 'Escape') {
      this.close();
    }
  }
  ngOnInit(): void {
  }
  close() {
    this.store.dispatch(new GlobalActions.CloseMap());
  }

  convertir(numero:string) {
    return Number(numero);
  }

}
